<template>
  <div class="deliveryOrder">
    <el-container>
      <el-main style="padding: 0; width: 100vh">
        <vm-table
            ref="vmTable"
            height="80vh"
            :filter.sync="filter"
            module="basic"
            url="sAPShipmentInvoices/selectSAPInvoiceWithPage"
            @update:filter="handleClick"
            @select="selectHandler"
            @select-all="selectHandler">
          <div slot="toolbar">
            <el-button :loading="printLoading" type="primary" @click="printInvoice">打印发货单</el-button>
            <!--            <el-button :loading="exportDeliveryLoading" type="primary" @click="exportDelivery">导出沃克斯送货单</el-button>-->
            <!--                        <el-select v-model.trim="customerName" clearable placeholder="请选择公司">-->
            <!--                          <el-option label="崇友" value="1"/>-->
            <!--                          <el-option label="其他" value="2"/>-->
            <!--                        </el-select>-->
            <el-button :loading="printCYSMLoading" type="primary" @click="printShipMark">打印唛头</el-button>
            <el-button :loading="exportCHLoading" type="primary" @click="exportCHPackingList">导出装箱清单</el-button>
            <el-select v-model.trim="customerName" style="width:150px;margin-left:5px" clearable placeholder="请选择公司">
              <el-option label="崇友" :value="1"/>
              <el-option label="永大" :value="2"/>
              <el-option label="沃克斯" :value="3"/>
              <el-option label="凯斯博" :value="4"/>
              <el-option label="东南专用" :value="5"/>
              <el-option label="重庆富士" :value="6"/>
              <el-option label="四川富士" :value="7"/>
              <el-option label="伊士顿" :value="8"/>
              <el-option label="蒂森备件中心" :value="9"/>
            </el-select>
          </div>
          <template slot="adSearch">
            <div class="vm-search">
              <vm-search label="发货单号">
                <el-input
                    v-model.trim="filter.invoiceNo"
                    type="textarea"
                    :autosize="{ minRows: 1, maxRows: 6 }"
                    clearable/>
              </vm-search>
              <vm-search label="出厂编号">
                <el-input
                    v-model.trim="filter.factoryNo"
                    type="textarea"
                    :autosize="{ minRows: 1, maxRows: 6 }"
                    clearable/>
              </vm-search>
              <vm-search label="销售单号">
                <el-input
                    v-model.trim="filter.salesOrder"
                    type="textarea"
                    :autosize="{ minRows: 1, maxRows: 6 }"
                    clearable/>
              </vm-search>
              <vm-search label="合同编号">
                <el-input v-model.trim="filter.clientContractNO" clearable/>
              </vm-search>
              <vm-search label="客户名称">
                <el-input v-model.trim="filter.purchaseUnit" clearable/>
              </vm-search>
              <vm-search label="打印状态">
                <el-select v-model.trim="filter.printQuantity" clearable placeholder="请选择打印状态">
                  <el-option label="已打印" value="已打印"/>
                  <el-option label="未打印" value="未打印"/>
                </el-select>
              </vm-search>
              <vm-search label="包装状态">
                <el-select v-model.trim="filter.packingState" clearable placeholder="请选择包装状态">
                  <el-option label="未包装" value="未包装"/>
                  <el-option label="已包装" value="已包装"/>
                </el-select>
              </vm-search>
              <vm-search label="包装类别">
                <el-select v-model.trim="filter.maxMinPacking" clearable placeholder="请选择包装类别">
                  <el-option label="大包装" value="大包装"/>
                  <el-option label="小包装" value="小包装"/>
                </el-select>
              </vm-search>
              <vm-search label="发货单状态">
                <el-select v-model.trim="filter.workflowStatus" clearable placeholder="请选择包装类别">
                  <el-option label="作废" value="作废"/>
                  <el-option label="未提交" value="未提交"/>
                  <el-option label="已提交" value="已提交"/>
                  <el-option label="销售员已确认" value="销售员已确认"/>
                  <el-option label="财务已确认" value="财务已确认"/>
                  <el-option label="已打印下发" value="已打印下发"/>
                </el-select>
              </vm-search>
              <vm-search label="交货日期" style="width: 460px">
                <el-date-picker
                    v-model="invoiceTime"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    style="width: 100%"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    @change="invoiceTimeChange"/>
              </vm-search>
              <vm-search label="送货地址">
                <el-input v-model="filter.shippingAddress" placeholder="请输入送货地址" clearable/>
              </vm-search>
              <vm-search label="制单日期" style="width: 460px">
                <el-date-picker
                    v-model="erdat"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    style="width: 100%"
                    value-format="yyyy-MM-dd"
                    @change="erdatChange"/>
              </vm-search>
              <!-- <vm-search label="打印下发时间" style="width: 460px">
               <el-date-picker
                    v-model="submitTime"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    style="width: 100%"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    @change="submitTimeChange"/>
              </vm-search> -->
            </div>
          </template>
          <el-table-column type="selection" align="center" width="50"/>
          <el-table-column prop="status" align="center" width="50" label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 10">暂停</span>
              <span v-else-if="scope.row.status === 20">撤销</span>
              <span v-else>正常</span>
            </template>
          </el-table-column>
          <el-table-column prop="priority" align="center" width="50" label="级别">
            <template slot-scope="scope">
              <span v-if="scope.row.priority > 1">优先</span>
              <span v-else>正常</span>
            </template>
          </el-table-column>
          <el-table-column prop="workflowStatus" align="center" width="100" label="订单状态"/>
          <el-table-column prop="printQuantity" align="center" width="50" label="打印次数">
            <template slot-scope="scope">
              <span v-if="scope.row.printQuantity === '' || scope.row.printQuantity === null">未打印</span>
              <span v-else>{{scope.row.printQuantity}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="maxMinPacking" align="center" width="80" label="包装类别"/>
          <el-table-column prop="packingState" align="center" width="80" label="包装状态"/>
          <el-table-column prop="invoiceNo" align="center" width="110" label="发货单号"/>
          <el-table-column prop="invoiceTime" align="center" width="110" label="交货日期"/>
          <el-table-column prop="salesOrder" align="center" width="100" label="销售订单"/>
          <el-table-column prop="factoryNo" align="center" width="100" label="出厂编号"/>
          <el-table-column prop="clientContractNO" align="center" width="120" label="合同编号"/>
          <el-table-column prop="employeeName" align="center" width="100" label="销售员"/>
          <el-table-column prop="purchaseUnit" align="center" width="200" label="购货单位"/>
          <el-table-column prop="projectName" align="center" width="200" label="项目名称"/>
          <el-table-column prop="shippingAddress" align="center" width="300" label="送货地址"/>
          <!-- <el-table-column prop="transportation" align="center" width="100" label="运输方式"/>
          <el-table-column align="center" width="80" label="物流详情">
            <template slot-scope="scope">
              <el-button type="text" @click="$refs.logisticsDetails.open(scope.row.invoiceNo)">查看</el-button>
            </template>
          </el-table-column> -->
          <el-table-column prop="erdat" align="center" width="120" label="制单日期"/>
          <el-table-column prop="bzBeiZhu" align="center" width="100" label="备注"/>
        </vm-table>
      </el-main>
    </el-container>
    <logistics-details ref="logisticsDetails"/>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import LogisticsDetails from "@/views/deliveryManage/LogisticsDetails";
  import DateUtil from "@/util/dateUtil";

  export default {
    name: "DeliveryOrder",
    components: {VmTable, VmSearch, LogisticsDetails},
    data() {
      return {
        selection: [],
        invoiceNoList: [],
        salesOrderList: [],
        ids: [],
        erdat: [],
        invoiceTime: [],
        submitTime: [],
        customerName: 1,
        printLoading: false,
        printCYSMLoading: false,
        exportDeliveryLoading: false,
        exportCHLoading: false,
        filter: {
          invoiceNo: "",
          factoryNo: "",
          salesOrder: "",
          clientContractNO: "",
          purchaseUnit: "",
          maxMinPacking: "",
          packingState: "",
          printQuantity: "",
          beignERDAT: "",//制单日期开始
          endERDAT: "",//制单日期结束
          invoiceTimeBegin: "",//交货日期结束
          invoiceTimeEnd: "",//交货日期结束
          submitTimeBegin: "",//交货日期结束
          submitTimeEnd: "",//交货日期结束
          shippingAddress: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      // 查询日期
      invoiceTimeChange(val) {
        if (val) {
          this.filter.invoiceTimeBegin = val[0];
          this.filter.invoiceTimeEnd = val[1];
        } else {
          this.filter.invoiceTimeBegin = "";
          this.filter.invoiceTimeEnd = "";
        }

      },
      erdatChange(val) {
        if (val) {
          this.filter.beignERDAT = val[0];
          this.filter.endERDAT = val[1];
        } else {
          this.filter.beignERDAT = "";
          this.filter.endERDAT = "";
        }
      },
      submitTimeChange(val) {
        if (val) {
          this.filter.submitTimeBegin = val[0];
          this.filter.submitTimeEnd = val[1];
        } else {
          this.filter.submitTimeBegin = "";
          this.filter.submitTimeEnd = "";
        }
      },
      // 重置
      handleClick() {
        this.invoiceTime = [];
        this.erdat = [];
        this.submitTime = [];
        this.getList();
      },
      // checkBox
      selectHandler(selection) {
        this.selection = selection;
        this.invoiceNoList = [];
        this.ids = [];
        this.salesOrderList = [];
        for (let item of this.selection) {
          this.invoiceNoList.push(item.invoiceNo);
          this.ids.push(item.pkid);
          this.salesOrderList.push(item.salesOrder);
        }
      },

      // 打印发货单
      printInvoice() {
        if (this.invoiceNoList.length === 0) {
          this.$message.error("请至少选择一条需要打印的发货单");
          return;
        }
        this.printLoading = true;
        this.$http
          .postForFile("basic", "sAPShipmentInvoices/printList", this.invoiceNoList)
          .then((res) => {
            console.log(res);
            let blob = new Blob([res.data], {type: "application/pdf"});
            let pdfUrl = window.URL.createObjectURL(blob);
            window.open(pdfUrl);
            this.printLoading = false;
            this.invoiceNoList = [];
            this.getList();
          }).catch(() => {
            this.invoiceNoList = [];
          });
      },
      // 打印唛头
      printShipMark() {
        if (this.customerName === 1) {
          this.printCYSMark();
        } else if (this.customerName === 2) {
          this.printYungtayShipMark();
        } else if (this.customerName === 4) {
          this.$router.push({path: "/KSBPrintModel"});
        } else if (this.customerName === 5) {
          this.$router.push({path: "/DNZYPrintModel"});
        } else if (this.customerName === 6) {
          this.$router.push({path: "/CQFSPrintModel"});
        } else if (this.customerName === 7) {
          this.$router.push({path: "/SCFSPrintModel"});
        } else if (this.customerName === 8) {
          this.$router.push({path: "/YSDPrintModel"});
        } else {
          this.$message.error("该客户无此功能");
        }
      },

      //打印崇友唛头
      printCYSMark() {
        if (this.invoiceNoList.length === 0) {
          this.$message.error("请至少选择一条需要打印的项目");
          return;
        }
        this.printCYSMLoading = true;
        this.$http
          .postForFile("basic", "sAPShipmentInvoices/printChongYouShipMark", this.invoiceNoList)
          .then((res) => {
            let blob = new Blob([res.data], {type: "application/pdf"});
            let pdfUrl = window.URL.createObjectURL(blob);
            window.open(pdfUrl);
            this.printCYSMLoading = false;
            this.invoiceNoList = [];
            this.getList();
          }).catch(() => {
            this.invoiceNoList = [];
          });
      },
      printYungtayShipMark() {
        if (this.invoiceNoList.length === 0) {
          this.$message.error("请至少选择一条需要打印的项目");
          return;
        }
        this.printCYSMLoading = true;
        this.$http
          .postForFile("basic", "sAPShipmentInvoices/printYungtayShipMark", this.salesOrderList)
          .then((res) => {
            let blob = new Blob([res.data], {type: "application/pdf"});
            let pdfUrl = window.URL.createObjectURL(blob);
            window.open(pdfUrl);
            this.printCYSMLoading = false;
            this.invoiceNoList = [];
            this.getList();
          }).catch(() => {
            this.invoiceNoList = [];
          });
      },

      exportCHPackingList() {
        if (this.customerName === 1) {
          this.exportPackingList("sAPShipmentInvoices/exportVks/exportPackingList_ch","崇友装箱清单.xls");
        } else if (this.customerName === 2) {
          this.exportPackingList("sAPShipmentInvoices/exportVks/exportPackingList_Yungtay","永大装箱清单.xls");
        } else if (this.customerName === 3) {
          this.exportPackingList("sAPShipmentInvoices/exportVks","沃克斯送货单.xlsx");
        } else if (this.customerName === 9) {
          this.exportPackingList("TkeShipments/exportPackingList_dsbjzx","蒂森备件中心装箱清单.xlsx");
        } else {
          this.$message.error("该客户无此功能。");
        }
      },
      exportPackingList(url,fileName) {
        if (this.ids.length === 0) {
          this.$message.error("请至少选择一条需要导出的项目");
          return;
        }
        this.exportCHLoading = true;
        this.$http
          .exportFile("basic", `${url}/${this.ids}`)
          .then((res) => {
            let blob = new Blob([res.data]);
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement("a");
            a.href = url;
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(url);
            // window.open(pdfUrl);
            this.exportCHLoading = false;
            this.selection = [];
            this.getList();
          }).catch(() => {
            this.selection = [];
            this.exportCHLoading = false;
          });
      },
      // exportDeliveryWKS() {
      //   if (this.ids.length === 0) {
      //     this.$message.error("请至少选择一条需要打印的项目");
      //     return;
      //   }
      //   this.exportDeliveryLoading = true;
      //   this.$http
      //     .exportFile("basic", `sAPShipmentInvoices/exportVks/${this.ids}`)
      //     .then((res) => {
      //       console.log(res);
      //       let blob = new Blob([res.data]);
      //       let url = window.URL.createObjectURL(blob);
      //       console.log(url);
      //       let a = document.createElement("a");
      //       a.href = url;
      //       a.download = "沃克斯送货单.xlsx";
      //       a.click();
      //       window.URL.revokeObjectURL(url);
      //       // window.open(pdfUrl);
      //       this.exportDeliveryLoading = false;
      //       this.invoiceNoList = [];
      //       this.getList();
      //     }).catch(() => {
      //       this.invoiceNoList = [];
      //       this.exportDeliveryLoading = false;
      //     });
      // },
    },
  };
</script>
<style lang="scss" scoped>
.deliveryOrder {
  .vm-page-table .ad-search .ad-search_content .ad-search-btn {
    height: 28px;
  }
}
</style>
